module.exports = __webpack_public_path__ + "static/zenva_beginners_javascript-c54e39c5520b06b30515fcefeac69527.pdf";